<iframe *ngIf="esTurnea" #miFrame [src]="url" style="width: 100%; height: 100%;"></iframe>
